import React, { createContext, useContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
   // State management
  const [serverError, setServerError] = useState('');
  const [allAttendance, setAllAttendance] = useState([]);

  // Combine everything into a single value object
  const value = useMemo(() => ({
    serverError,
    setServerError,
    allAttendance,
    setAllAttendance
  }), [serverError, allAttendance]);

  return <AuthContext.Provider value={value}>
    {children}
  </AuthContext.Provider>;
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};

// Custom hook to use the FormContext
export const useFormContext = () => {
  return useContext(AuthContext);
};
